import { render, staticRenderFns } from "./ViolateWordForm.vue?vue&type=template&id=1e12e384&scoped=true"
import script from "./ViolateWordForm.vue?vue&type=script&lang=js"
export * from "./ViolateWordForm.vue?vue&type=script&lang=js"
import style0 from "./ViolateWordForm.vue?vue&type=style&index=0&id=1e12e384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e12e384",
  null
  
)

export default component.exports